import React from "react";
import '../css/global.css';
import '../css/About.css';
import laptopAsset from '../images/laptop-asset.webp';
import bellaPolaroid from '../images/bella-polaroid.webp';

const About: React.FC = () => {
    return(
        <section className="about" id="about">
            <div className="container">
              <div className="row">
                <div className="about-col col-sm-3">
                    <img src={laptopAsset}
                        className="img-fluid"
                        alt="3D Laptop, mug, plant and camera"
                    />
                </div>
                <div className="about-col col-sm-3">
                <div className="header-content">
                <span className="sub-heading">About Me</span>
                <h3>Hi, I'm Stephanie!</h3>
                <div className="section-divider">
                    <svg
                        width="80"
                        height="16"
                        viewBox="0 0 80 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 8 C8 2, 14 2, 20 8
                            S32 14, 38 8
                            S50 2, 56 8
                            S68 14, 78 8"
                            stroke="#ec7d9f"
                            strokeWidth="4"
                            strokeLinecap="round"
                            fill="none"
                        />
                    </svg>
                </div>
              </div>
                <p>
                    I'm a frontend developer with 10 years of experience building websites. I love turning ideas into clean, creative interfaces and solving problems with code. I also love learning new things! Over the years, web technologies have evolved, and I've gone from primarily using HTML, CSS, and JavaScript to working with React, Next.js, and Django.
                    <br /><br />
                    When I'm not coding, you can find me creating conceptual photography, exploring 2D and 3D illustrations, working out, or spending time with my dog, Bella.
                </p>
                 
                </div>
                <div className="about-col col-sm-3">
                    <img src={bellaPolaroid}
                        className="img-fluid"
                        alt="Bella"
                    />
                </div>
              </div>
            </div>
        </section>
    )
    ;}

    export default About;
